<template>
    <f7-page
        name="Invite your Partner"
        class="onboardingBg"
    >
        <f7-navbar
            large
            title-large="Invite your partner"
            large-transparent
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    v-if="!inPopup"
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>Invite your partner</f7-nav-title>
            <f7-nav-right>
                <f7-link
                    v-if="inPopup"
                    aria-label="Close"
                    href="#"
                    style="padding: 0 10px 0;"
                    @click="closePopup();"
                >
                    <i
                        class="icon ion-close-round"
                        style="font-size: 20px"
                    />
                </f7-link>
            </f7-nav-right>
        </f7-navbar>
        <f7-block style="margin: 12px auto 0; max-width: 380px; text-align: center">Send your partner a message to hook-up on Coral.</f7-block>
        <f7-list
            v-if="!user.name || user.name.length < 5"
            no-hairlines
            form
            style="max-width: 400px; margin: 20px auto 0px;"
        >
            <f7-list-input
                :value="user.name"
                label="Your name"
                type="text"
                placeholder="Your name"
                @input="user.name=$event.target.value;"
                @change="saveUser()"
            />
        </f7-list>
        <f7-list
            no-hairlines
            form
            style="max-width: 400px; margin: 20px auto 0px;"
        >
            <template v-if="invitationMode === 'email'">
                <f7-list-input
                    autocomplete="email"
                    label="Your Partner's email"
                    type="email"
                    placeholder="their@email.com"
                    @input="email=($event.target.value || '')"
                    @change="email=($event.target.value || ''); changeEmail();"
                >
                    <f7-link
                        v-if="isPgap"
                        slot="label"
                        style="float: right; color: #777"
                        @click="invitationMode = 'phone'; phone = ''; email = ''; switchMode('phone')"
                    >use phone</f7-link>
                </f7-list-input>
            </template>
            <template v-else>
                <f7-list-input
                    :value="phone"
                    autocomplete="phone"
                    label="Your Partner's phone number"
                    type="text"
                    name="phone"
                    placeholder="+1 (917) 123 4839"
                    @input="phone=($event.target.value || '')"
                    @change="phone=($event.target.value || ''); changePhone();"
                >
                    <f7-link
                        slot="label"
                        style="float: right; color: #777"
                        @click="invitationMode = 'email'; phone = ''; email = ''; switchMode('email')"
                    >use email</f7-link>
                </f7-list-input>

            </template>
            <f7-list-input
                :value="message"
                autocomplete="none"
                label="Personal message"
                input-style="min-height: 100px"
                type="textarea"
                name="message"
                resizable
                placeholder="This message will be sent to your partner. Need a hand? Try one of our our pre-written messages below! "
                @input="message=($event.target.value || '')"
                @change="message=($event.target.value || '')"
            />
        </f7-list>
        <f7-block-title style="max-width: 400px; padding: 0 16px; margin: 0px auto 1px;color: #686868; text-align: left;">
            Choose a pre-written message below
        </f7-block-title>

        <f7-segmented
            :class="`segOnb2`"
            strong
            tag="p"
            style="max-width: 400px; margin: -14px auto 40px; background: transparent; padding: 3px 13px;"
        >
            <f7-button
                v-for="(m, index) in messages"
                :active="m.active"
                :key="`m-${index}`"
                style="text-transform: uppercase; font-size: 15px; color: #fc6f65; padding: 0 4px 0 4px; width: auto"
                @click="changeMessage(index);"
            >{{ m.title }}</f7-button>
        </f7-segmented>

        <f7-block style="margin-top: -10px; margin-bottom: 10px; border: 0px solid white">

            <div
                v-if="!user.hasPartner"
                style="margin: 0 auto; max-width: 380px; text-align: center"
            >

                <f7-button
                    v-if="invitationMode === 'email'"
                    style="width: 220px"
                    large
                    round
                    fill
                    color="red"
                    @click="send()"
                >SEND</f7-button>
                <f7-link
                    v-else
                    :href="`#`"
                    external
                    target="_system"
                    style="width: 220px"
                    class="external button button-round button-fill button-large color-red"
                    @click="send()"
                >SEND</f7-link>

                <f7-button
                    class="minorActions"
                    style="color: #686868;  line-height:60px; height: 60px; letter-spacing: -.3px"
                    href="#"
                    @click="closePopup(); maybeLater();"
                >Maybe later</f7-button>

            </div>
            <div
                v-else
                style="margin: 0 auto; max-width: 380px; text-align: center"
            >
                <p>
                    Unfortunatelly we do not support multiple partners at the moment.
                </p>
                <f7-button
                    class="minorActions"
                    style="color: #686868;  line-height:60px; height: 60px; letter-spacing: -.3px"
                    href="#"
                    @click="closePopup();"
                >Ok close</f7-button>

            </div>

        </f7-block>

    </f7-page>
</template>

<script>
export default {
    store: ['api', 'text', 'user', 'partners'],
    data () {
        return {
            messageActivated: false,
            inPopup: false,
            invitationMode: pgap ? 'phone' : 'email',
            email: '',
            phone: '',
            message: '',
            messages: [
                {
                    title: 'FUN',
                    message: `Hi Honey,
I found a sex and intimacy app that I think will be fun to try together. Would you like to partner with me on Coral and see where it leads?
`,
                    active: false,
                },
                {
                    title: 'ROMANTIC',
                    message: `Hi Lover,
There’s nobody else in the world I’d rather experience pleasure and intimacy with than you. Will you partner with me on Coral to start our journey today?
`,
                    active: false,
                },
                {
                    title: 'SWEET',
                    message: `OMG,
I found a sex and intimacy app that’s going to take our sex life to the next level. Will you partner with me on Coral to start our journey today?
`,
                    active: false,
                },
                {
                    title: 'SEXY',
                    message: `Hey sweetheart,
I found a sex and intimacy app that made me think about how much I love being with you. Will you partner with me on Coral to make our connection even deeper?
`,
                    active: false,
                },
                {
                    title: 'PLAYFUL',
                    message: `Hey boo,
I thought it could be fun for us to try this intimacy app together. Want to give it a shot?
`,
                    active: false,
                }
            ]
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    created: function () {
        if (this.$f7router.view.main) {
            this.inPopup = false;
        } else {
            this.inPopup = true;
        }
    },
    mounted: function () { },
    methods: {
        changePhone: function () {
            if (this.phone[0] === '0' && this.phone[1] === '0') {
                this.phone = this.phone.replace('00', '+');
            }
            // this.phone = '+' + this.phone.replace(/\D/g, '');
        },
        changeEmail: function () {
            this.email = this.email.toLowerCase().replace('mailto:', '');
        },
        changeMessage: function (index) {
            for (let i = 0; i < this.messages.length; i++) {
                this.messages[i].active = false;
            }
            this.messages[index].active = true;
            this.$events.fire('trackEvent', `partners_invite_canned_message`, 'partners', index);
            setTimeout(() => {
                this.messages[index].active = false;
            }, 300);
            this.message = this.messages[index].message;
        },
        switchMode: function () {

        },
        closePopup: function () {
            if (this.inPopup) {
                if (f7.popup.get(`#${this.$f7router.view.name}`)) {
                    f7.popup.get(`#${this.$f7router.view.name}`).open();
                    f7.popup.get(`#${this.$f7router.view.name}`).close();
                }
            } else {
                this.$f7router.view.router.back();
            }
        },
        send: async function () {
            if (this.user.name.length < 3) return f7.dialog.alert("Name is too short.");
            if (this.invitationMode === 'email') {
                if (this.email.length < 3) return f7.dialog.alert("Invalid invitation email.");
            } else {
                if (this.phone.length < 5) {
                    return f7.dialog.alert("Invalid phone number.");
                }
                if (!this.phone.includes('+')) {
                    // Get from free twilio API
                    this.phone = await this.getPhoneWithAreaCode(this.phone.replace(/\D/g, ''));
                }
                this.phone = `+${this.phone.replace(/\D/g, '')}`;
            }
            if (this.message.length < 3) return f7.dialog.alert("You must include a personal message.");
            // if (this.invitationMode === 'phone') {
            //     return f7.dialog.alert('Phone mode is not setup yet.');
            // }
            f7.preloader.show();
            this.$http.post(`${this.api}/partners`, {
                invitationMode: this.invitationMode,
                invitationAddress: this.invitationMode === 'phone' ? this.phone : this.email,
                message: this.message,
            }).then(
                response => {
                    this.partners.push(response.body);
                    if (this.invitationMode === 'email') {
                        f7.dialog.alert(`Your invitation is on it's way to your partner. We'll let you know when they join.`, 'Success!');
                    } else {
                        window.open(`sms:${this.phone}?&body=${this.message.replace(',', ', %0a')} %0a%0aGet it here: https%3A%2F%2Fgetcoral.app %0a%0aPS: You must sign up with this phone number for our accounts to link!`, "_system")
                    }
                    this.closePopup();
                    f7.preloader.hide();
                },
                response => {
                    f7.preloader.hide();
                    f7.dialog.alert(response.body.message || 'Unknown error');
                }
            );
        },
        getPhoneWithAreaCode: async function (phone) {
            // this is not ideal but this is a quick fix
            // Ideally let's move the whole firebase logic to the backend
            // And write the business logic of the phone numbers there into one call
            let response;
            try {
                // Get the phone with a proper area code
                response = (await this.$http.get(`${this.api}/phone/${phone}`)).body.phone;
            } catch (error) {
                response = phone;
                console.error("An error occurred while trying to get the phone number", error);
            }

            return response;
        },
        saveUser: function () {
            this.$http.put(`${this.api}/users/${this.user.id}`, this.user).then(
                response => {
                    this.user = response.body;
                },
                response => {
                    f7.dialog.alert(response.body.message || 'Something went wrong');
                }
            );
        },
        maybeLater: function () {
            this.$events.fire('trackEvent', `partners_maybe_later`, 'partners');
        }
    }
};
</script>
<style lang="less">
.segOnb2 {
    .segmented-highlight {
        opacity: 0;
    }
    &.activated {
        .segmented-highlight {
            opacity: 1;
        }
    }
}
</style>
<style lang="less" scoped>
@import '../../css/colors.less';
.block-title {
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
    color: black;
    font-weight: bold;
}
.list.inset {
    border: 3px solid @black;
    border-radius: 0px;
}
.center {
    text-align: center;
}
</style>
